module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "find-pas"
  }, [_c('div', {
    staticClass: "top2"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pass),
      expression: "pass"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请输入新密码"
    },
    domProps: {
      "value": (_vm.pass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repass),
      expression: "repass"
    }],
    attrs: {
      "type": "password",
      "placeholder": "请再次输入新密码"
    },
    domProps: {
      "value": (_vm.repass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repass = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorShow),
      expression: "errorShow"
    }],
    staticClass: "wrongs"
  }, [_vm._v(_vm._s(_vm.errorMsg))]), _vm._v(" "), _c('div', {
    staticClass: "login-btn",
    on: {
      "click": _vm.sure
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('successalert', {
    attrs: {
      "show": _vm.show,
      "msg": _vm.msg
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6007e4f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/findPas/newPas.vue
// module id = 108
// module chunks = 1